<ng-container *ngIf="user$ | async as user">
  <ng-container *ngIf="post$ | async as post; else errorMessage">
    <sales-common-loop-v2-post [post]="post" [currentUser]="user"></sales-common-loop-v2-post>
  </ng-container>
  <ng-template #errorMessage>
    <div *ngIf="!loading">
      <uikit-empty-state iconName="error" title="{{ 'FRONTEND.LOOP.ERRORS.ERROR_LOADING_POST.TITLE' | translate }}">
        <span state-description>
          {{ 'FRONTEND.LOOP.ERRORS.ERROR_LOADING_POST.MSG' | translate }}
        </span>
      </uikit-empty-state>
    </div>
  </ng-template>

  <div *ngIf="loading">
    <div class="stream-item">
      <div class="stream-item-container stencil-shimmer"></div>
    </div>
  </div>
</ng-container>
